import { Button } from "@devhop/ui";
import { RefreshCwIcon } from "lucide-react";
import { formatDateTimeLocal } from "@/shared/lib/date-time-performance";
import type { GoogleCalendarSyncStatusDTO } from "../../domain/contracts/google-calendar";

const STATE_LABELS: Record<GoogleCalendarSyncStatusDTO["state"], string> = {
  synced: "ຊິງຄ໌ແລ້ວ",
  pending: "ລໍຖ້າຊິງຄ໌",
  error: "ຊິງຄ໌ບໍ່ສຳເລັດ",
  idle: "ບໍ່ມີລາຍການເທິງປະຕິທິນ",
};

export function GoogleCalendarSyncCard({
  status,
  canSync,
  isSyncing,
  onSync,
}: {
  status: GoogleCalendarSyncStatusDTO | undefined;
  canSync: boolean;
  isSyncing: boolean;
  onSync: () => void;
}) {
  if (!status?.enabled) return null;

  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-xl border bg-card px-5 py-4">
      <div>
        <p className="font-semibold text-sm">Google Calendar</p>
        <p className="mt-1 text-muted-foreground text-sm">
          {STATE_LABELS[status.state]}
          {status.itemCount > 0 ? ` · ${status.itemCount} ລາຍການ` : ""}
        </p>
        {status.lastSyncedAt ? (
          <p className="mt-1 text-muted-foreground text-xs">
            ຊິງຄ໌ລ່າສຸດ {formatDateTimeLocal(new Date(status.lastSyncedAt))}
          </p>
        ) : null}
        {status.state === "error" && status.lastError ? (
          <p className="mt-1 text-destructive text-xs">{status.lastError}</p>
        ) : null}
      </div>
      {canSync ? (
        <Button variant="outline" onClick={onSync} disabled={isSyncing}>
          <RefreshCwIcon className="size-4" />
          {isSyncing ? "ກຳລັງຊິງຄ໌..." : "ຊິງຄ໌ Google Calendar"}
        </Button>
      ) : null}
    </div>
  );
}
